import { render, staticRenderFns } from "./OtherNationalities.vue?vue&type=template&id=faa3a21c&"
import script from "./OtherNationalities.vue?vue&type=script&lang=js&"
export * from "./OtherNationalities.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports